import { useState, useEffect } from "react";
import { router } from "expo-router";
import { getPendingEnvironmentSwitch, setPendingEnvironmentSwitch, switchEnvironment } from "./environment-store";

/**
 * When the env screen navigates to login after user confirms a switch, the pending
 * switch is consumed here to avoid running clearAuth/setEnvironment while the
 * env screen is still mounted (which can cause an RN/Hermes crash).
 * Use on the login screen (or any single consumer after navigation).
 *
 * Once the switch settles, navigates to `/` so the AuthProvider gate picks the
 * sign-in flow from the `legacy_auth` flag (Auth0 SignInScreen, or back to
 * /auth/login for legacy). Staying on /auth/login would pin the user to the
 * legacy form, because the gate skips AUTH_SCREENS.
 */
export function usePendingEnvironmentSwitch(): { isSwitching: boolean } {
  const [isSwitching, setIsSwitching] = useState(false);

  useEffect(() => {
    const pending = getPendingEnvironmentSwitch();
    if (!pending) return;
    setIsSwitching(true);
    switchEnvironment(pending)
      .finally(() => {
        setPendingEnvironmentSwitch(null);
        setIsSwitching(false);
        router.replace("/");
      })
      .catch((err) => {
        console.error("[usePendingEnvironmentSwitch] Switch failed:", err);
      });
  }, []);

  return { isSwitching };
}
